import React from 'react';

/**
 * Button Component
 * A flexible, accessible button component with multiple variants and sizes
 */
const Button = ({
  children,
  variant = 'primary', // primary, secondary, outline, ghost, danger
  size = 'md', // sm, md, lg, icon
  disabled = false,
  loading = false,
  onClick,
  type = 'button',
  icon,
  className = '',
  ...props
}) => {
  const baseClass = 'btn';
  const variantClass = `btn-${variant}`;
  const sizeClass = size !== 'md' ? `btn-${size}` : '';
  
  const combinedClassName = [
    baseClass,
    variantClass,
    sizeClass,
    className
  ].filter(Boolean).join(' ');

  return (
    <button
      type={type}
      className={combinedClassName}
      disabled={disabled || loading}
      onClick={onClick}
      {...props}
    >
      {loading && (
        <span className="spinner" />
      )}
      {icon && !loading && icon}
      {children}
    </button>
  );
};

export default Button;

// Usage Examples:
/*
// Primary button
<Button onClick={handleClick}>Save Changes</Button>

// Secondary button with icon
<Button variant="secondary" icon={<CheckIcon />}>
  Complete
</Button>

// Outline button (small)
<Button variant="outline" size="sm">
  Cancel
</Button>

// Loading state
<Button loading={isLoading}>
  {isLoading ? 'Saving...' : 'Save'}
</Button>

// Danger button
<Button variant="danger" onClick={handleDelete}>
  Delete
</Button>

// Icon only button
<Button variant="ghost" size="icon">
  <SettingsIcon />
</Button>
*/
